export default __webpack_public_path__ + "static/media/wave.4200819d.svg";